import type { CanDeactivateFn } from '@angular/router'

export type UnsavedBlogEditor = {
  hasUnsavedChanges(): boolean
}

export const blogUnsavedChangesGuard: CanDeactivateFn<UnsavedBlogEditor> = (
  component
) =>
  !component.hasUnsavedChanges() ||
  window.confirm('Discard unsaved blog changes?')
